import { useEffect, useState } from 'react'
import './Furnizori.css'
import AddFurnizor from '../components/new/addFurnizor'

const GET_SUPPLIERS_API_URL = 'https://dyt8xo9cba.execute-api.eu-central-1.amazonaws.com/techStage/getSuppliers'

function Furnizori() {
    const [furnizori, setFurnizori] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState('')
    const [openId, setOpenId] = useState(null)
    const [isSupplierModalOpen, setIsSupplierModalOpen] = useState(false)
    const [modalMode, setModalMode] = useState('new')
    const [search, setSearch] = useState('')

    const [supplierForm, setSupplierForm] = useState({
        id: null,
        logo: '',
        alias: '',
        imageUpload: null,
        nume: '',
        cui: '',
        website: '',
        website_username: '',
        website_password: '',
        note: ''
    })

    const [contactsForm, setContactsForm] = useState([
        {
            id: null,
            nume: '',
            functie: '',
            email: '',
            telefon: ''
        }
    ])

    const [addressesForm, setAddressesForm] = useState([
        {
            id: null,
            nume: '',
            adresa: ''
        }
    ])

    useEffect(() => {
        getFurnizori()
    }, [])

    useEffect(() => {
        const timer = setTimeout(() => {
            getFurnizori(search)
        }, 300)

        return () => clearTimeout(timer)
    }, [search])

    async function getFurnizori(searchValue = '') {
        try {
            setLoading(true)
            setError('')

            const url = searchValue.trim()
                ? `${GET_SUPPLIERS_API_URL}?search=${encodeURIComponent(searchValue.trim())}`
                : GET_SUPPLIERS_API_URL

            const response = await fetch(url, {
                method: 'GET'
            })

            const text = await response.text()

            if (!response.ok) {
                throw new Error(`Request failed: ${response.status}`)
            }

            const data = JSON.parse(text)

            setFurnizori(Array.isArray(data.suppliers) ? data.suppliers : [])
        } catch (err) {
            console.error('GET FURNIZORI ERROR:', err)
            setError('Nu am putut încărca furnizorii.')
        } finally {
            setLoading(false)
        }
    }
    function toggleSupplier(id) {
        setOpenId((currentId) => (currentId === id ? null : id))
    }

    function resetForms() {
        setSupplierForm({
            id: null,
            logo: '',
            alias: '',
            imageUpload: null,
            nume: '',
            cui: '',
            website: '',
            website_username: '',
            website_password: '',
            note: ''
        })

        setContactsForm([
            {
                id: null,
                nume: '',
                functie: '',
                email: '',
                telefon: ''
            }
        ])

        setAddressesForm([
            {
                id: null,
                nume: '',
                adresa: ''
            }
        ])
    }

    function openNewSupplierModal() {
        resetForms()
        setModalMode('new')
        setIsSupplierModalOpen(true)
    }

    function openEditSupplierModal(furnizor) {
        setSupplierForm({
            id: furnizor.id,
            logo: furnizor.logo || '',
            alias: furnizor.alias || '',
            imageUpload: null,
            nume: furnizor.nume || '',
            cui: furnizor.cui || '',
            website: furnizor.website || '',
            website_username: furnizor.website_username || '',
            website_password: furnizor.website_password || '',
            note: furnizor.note || ''
        })
        setContactsForm(
            Array.isArray(furnizor.contacte) && furnizor.contacte.length > 0
                ? furnizor.contacte.map((contact) => ({
                    id: contact.id || null,
                    nume: contact.nume || '',
                    functie: contact.functie || '',
                    email: contact.email || '',
                    telefon: contact.telefon || ''
                }))
                : [
                    {
                        id: null,
                        nume: '',
                        functie: '',
                        email: '',
                        telefon: ''
                    }
                ]
        )

        setAddressesForm(
            Array.isArray(furnizor.adrese) && furnizor.adrese.length > 0
                ? furnizor.adrese.map((address) => ({
                    id: address.id || null,
                    nume: address.nume || '',
                    adresa: address.adresa || ''
                }))
                : [
                    {
                        id: null,
                        nume: '',
                        adresa: ''
                    }
                ]
        )

        setModalMode('edit')
        setIsSupplierModalOpen(true)
    }


    return (
        <section className="furnizoriPage">
            <div className="furnizoriHeader">
                <div>
                    <h1>Furnizori</h1>
                </div>

                <button
                    type="button"
                    className="addSupplierButton"
                    onClick={openNewSupplierModal}
                >
                    + Adaugă furnizor
                </button>
            </div>
            <div className="furnizoriSearch">
                <span>⌕</span>

                <input
                    type="text"
                    value={search}
                    onChange={(event) => setSearch(event.target.value)}
                    onKeyDown={(event) => {
                        if (event.key === 'Escape') {
                            setSearch('')
                        }
                    }}
                    placeholder="Caută după nume furnizor, CUI sau website..."
                />

                {search && (
                    <button
                        type="button"
                        className="searchClearButton"
                        onClick={() => setSearch('')}
                    >
                        ×
                    </button>
                )}
            </div>
            {loading && (
                <div className="furnizoriMessage">
                    Se încarcă furnizorii...
                </div>
            )}

            {error && (
                <div className="furnizoriError">
                    {error}
                </div>
            )}

            {!loading && !error && furnizori.length === 0 && (
                <div className="furnizoriMessage">
                    Nu există furnizori încă.
                </div>
            )}

            {!loading && !error && furnizori.length > 0 && (
                <div className="furnizoriList">
                    {furnizori.map((furnizor) => {
                        const isOpen = openId === furnizor.id

                        return (
                            <article
                                className={`furnizorCard ${isOpen ? 'furnizorCardOpen' : ''}`}
                                key={furnizor.id}
                            >
                                <div className="furnizorMain">
                                    <button
                                        type="button"
                                        className="furnizorToggle"
                                        onClick={() => toggleSupplier(furnizor.id)}
                                    >
                                        <div className="furnizorInfo">
                                            <div className="furnizorLogo">
                                                {furnizor.logo ? (
                                                    <img
                                                        src={furnizor.logo}
                                                        alt={furnizor.nume}
                                                    />
                                                ) : (
                                                    <div className="furnizorLogoPlaceholder">
                                                        {String(furnizor.nume || '?').charAt(0).toUpperCase()}
                                                    </div>
                                                )}
                                            </div>

                                            <div className="furnizorText">
                                                <h2 title={furnizor.nume || ''}>
                                                    {furnizor.alias || furnizor.nume}
                                                </h2>
                                                <p>{furnizor.cui}</p>
                                            </div>
                                        </div>

                                        <span className="furnizorArrow">›</span>
                                    </button>

                                    <button
                                        type="button"
                                        className="editSupplierButton"
                                        onClick={() => openEditSupplierModal(furnizor)}
                                        aria-label="Editează furnizor"
                                    >
                                        <svg viewBox="0 0 24 24">
                                            <path d="M3 17.25V21h3.75L17.8 9.95l-3.75-3.75L3 17.25Zm17.7-10.2c.4-.4.4-1 0-1.4l-2.35-2.35a1 1 0 0 0-1.4 0l-1.85 1.85 3.75 3.75 1.85-1.85Z" />
                                        </svg>
                                    </button>
                                </div>



                                {isOpen && (
                                    <div className="furnizorDetailsNew">
                                        <div className="furnizorDetailsRow">
                                            <div className="furnizorPanel authPanel">
                                                <div className="authHeader">
                                                    <div className="authHeader">
                                                        <h3>🔒 Date autentificare website</h3>

                                                        {furnizor.website && (
                                                            <a
                                                                href={furnizor.website}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                                className="productLinkButton"
                                                            >
                                                                Website

                                                                <svg
                                                                    viewBox="0 0 24 24"
                                                                    width="14"
                                                                    height="14"
                                                                    fill="none"
                                                                    stroke="currentColor"
                                                                    strokeWidth="2"
                                                                >
                                                                    <path d="M14 3h7v7" />
                                                                    <path d="M10 14L21 3" />
                                                                    <path d="M21 14v4a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h4" />
                                                                </svg>
                                                            </a>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="authGrid">
                                                    <div className="authField">
                                                        <span>Username</span>

                                                        <div className="copyValueRow">
                                                            <strong>{furnizor.website_username || '-'}</strong>

                                                            <button
                                                                type="button"
                                                                className="copyButton"
                                                                onClick={async () => {
                                                                    await navigator.clipboard.writeText(furnizor.website_username || '')

                                                                    const toast = document.createElement('div')
                                                                    toast.className = 'copyToast'
                                                                    toast.textContent = 'Username copiat'

                                                                    document.body.appendChild(toast)

                                                                    setTimeout(() => {
                                                                        toast.classList.add('show')
                                                                    }, 10)

                                                                    setTimeout(() => {
                                                                        toast.classList.remove('show')

                                                                        setTimeout(() => {
                                                                            toast.remove()
                                                                        }, 250)
                                                                    }, 1800)
                                                                }}
                                                            >
                                                                <svg viewBox="0 0 24 24">
                                                                    <path d="M16 1H6a2 2 0 0 0-2 2v12h2V3h10V1Zm3 4H10a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Zm0 16H10V7h9v14Z" />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <div className="authField">
                                                        <span>Password</span>

                                                        <div className="copyValueRow">
                                                            <strong>{furnizor.website_password || '-'}</strong>

                                                            <button
                                                                type="button"
                                                                className="copyButton"
                                                                onClick={async () => {
                                                                    await navigator.clipboard.writeText(furnizor.website_password || '')

                                                                    const toast = document.createElement('div')
                                                                    toast.className = 'copyToast'
                                                                    toast.textContent = 'Parolă copiată'

                                                                    document.body.appendChild(toast)

                                                                    setTimeout(() => {
                                                                        toast.classList.add('show')
                                                                    }, 10)

                                                                    setTimeout(() => {
                                                                        toast.classList.remove('show')

                                                                        setTimeout(() => {
                                                                            toast.remove()
                                                                        }, 250)
                                                                    }, 1800)
                                                                }}
                                                            >
                                                                <svg viewBox="0 0 24 24">
                                                                    <path d="M16 1H6a2 2 0 0 0-2 2v12h2V3h10V1Zm3 4H10a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Zm0 16H10V7h9v14Z" />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="furnizorPanel notesPanel">
                                                <h3>📝 Notițe</h3>
                                                <p>{furnizor.note || 'Nu există notițe.'}</p>
                                            </div>
                                        </div>

                                        <div className="furnizorDetailsRow">
                                            <div className="furnizorPanel contactsPanel">
                                                <div className="panelHeader">
                                                    <h3>👤 Contacte</h3>


                                                </div>

                                                {Array.isArray(furnizor.contacte) && furnizor.contacte.length > 0 ? (
                                                    <div className="simpleTable">
                                                        <div className="simpleTableHead">
                                                            <span>Nume</span>
                                                            <span>Funcție</span>
                                                            <span>Email</span>
                                                            <span>Telefon</span>
                                                        </div>

                                                        {furnizor.contacte.map((contact) => (
                                                            <div className="simpleTableRow" key={contact.id}>
                                                                <strong>{contact.nume || '-'}</strong>
                                                                <span>{contact.functie || '-'}</span>
                                                                <span>{contact.email || '-'}</span>
                                                                <span>{contact.telefon || '-'}</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <p className="emptyPanelText">Nu există contacte.</p>
                                                )}
                                            </div>

                                            <div className="furnizorPanel addressesPanel">
                                                <div className="panelHeader">
                                                    <h3>📍 Adrese</h3>


                                                </div>
                                                

                                                {Array.isArray(furnizor.adrese) && furnizor.adrese.length > 0 ? (
                                                    <div className="simpleTable addressTable">
                                                        <div className="simpleTableHead">
                                                            <span>Nume</span>
                                                            <span>Adresă</span>
                                                        </div>

                                                        {furnizor.adrese.map((address) => (
                                                            <div className="simpleTableRow" key={address.id}>
                                                                <strong>{address.nume || 'Adresă'}</strong>
                                                                <span>{address.adresa || '-'}</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <p className="emptyPanelText">Nu există adrese.</p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </article>
                        )
                    })}
                </div>
            )}

       <AddFurnizor
    isOpen={isSupplierModalOpen}
    mode={modalMode}
    initialSupplier={supplierForm}
    initialContacts={contactsForm}
    initialAddresses={addressesForm}
    onClose={() => setIsSupplierModalOpen(false)}
    onSaved={async () => {
        await getFurnizori(search)
        setIsSupplierModalOpen(false)
    }}
/>
        </section>
    )
}

export default Furnizori